$(document).ready(function ($) {

  // Open Destinations dropdown
  $('a').on('click', function (e) {
    if ($(this).text().trim() === "Destinations") {
      e.preventDefault();
      e.stopPropagation(); // conflict avoid
      $(".destinations_container").css('display', 'flex');
      $(".target_continent").first().click();
    }
  });

  // Close icon
  $(".hux-closes-icon").on('click', function (e) {
    e.stopPropagation();
    $(".destinations_container").css('display', 'none');
  });

  // Continent switch
  $(".target_continent").on('click', function (e) {
    e.stopPropagation();
    var continent = $(this).data('target');
    $(".common_continent").hide();
    $("." + continent).show();
  });

  // 🔥 CLICK OUTSIDE TO CLOSE (NO CONFLICT)
  $(document).on('click', function (e) {
    if (
      $(".destinations_container").is(":visible") &&
      !$(e.target).closest('.destinations_container').length &&
      !$(e.target).closest('a').filter(function () {
        return $(this).text().trim() === "Destinations";
      }).length
    ) {
      $(".destinations_container").css('display', 'none');
    }
  });

});



jQuery(document).ready(function ($) {

  const dropdownMenus = ["Destinations", "Trip Type"];

  $('.main-nav__item .main-nav__top-link').each(function () {

    let menuText = $(this).text().trim();

    if (dropdownMenus.includes(menuText)) {

      let parentItem = $(this).closest('.main-nav__item');
      parentItem.addClass('has-mega-dropdown');

      if (!$(this).find('.main-nav__link-icon').length) {
        $(this).append(`
          <svg class="main-nav__link-icon">
            <use xlink:href="#svg-icon-arrow-down"></use>
          </svg>
        `);
      }
    }
  });

});
